import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs';
import { ofType } from 'src/core/engine/rxjs/ofType';
import { Action } from 'redux';
import { StorageMsg, StorageActions } from 'src/core/engine';

import { Actions, STORAGE_KEY } from '../user.actions';
import { AppendState, UserState } from '../user.reducer';

const ONE_DAY = 60 * 60 * 24 * 1000;
const LOGIN_TIMEOUT = ONE_DAY * 30;

export function persistUserEpic(action$: Observable<any>, state$: Observable<AppendState>): Observable<Action> {
    return action$.pipe(
        ofType<Actions>('User.Persist'),
        withLatestFrom(state$.pipe(map((s: any) => s?.user))),
        map(([, user]: [unknown, UserState]) => {
            /**
             * We don't want to persist anything
             */
            const { session, token } = user;
            const expiry = new Date().getTime() + LOGIN_TIMEOUT;
            const payload = {
                key: STORAGE_KEY,
                value: {
                    session,
                    token,
                },
                expiry,
            };
            return StorageMsg(StorageActions.Set, payload);
        }),
    );
}
